import React from 'react';

import {BulkActionResult} from 'src/components/bulk-tool';

import {AssignProductAccountEntitlementsResultModal} from './assign-product-account-entitlements.result.modal';
import {
    clearResult,
    selectAssignProductAccountEntitlementsBulkUuid,
    selectAssignProductAccountEntitlementsShown,
    selectAssignProductAccountEntitlementsTask,
} from './assign-product-account-entitlements.slice';


export const AssignProductAccountEntitlementsResult = () => (
    <BulkActionResult
        actionIdSelector={selectAssignProductAccountEntitlementsBulkUuid}
        actionTaskSelector={selectAssignProductAccountEntitlementsTask}
        actionShownSelector={selectAssignProductAccountEntitlementsShown}
        clearResult={clearResult}>
        {({id, onClose}) => (
            <AssignProductAccountEntitlementsResultModal id={id} onClose={onClose}/>
        )}
    </BulkActionResult>
);
